exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#swiper__media-calls {\n\ttransition: opacity 1s;\n\topacity:1;\n}\n\n", ""]);

// exports
